import { Box, SxProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import {
  IKeyboardProps,
  ISimpleKeyboardRef,
  Keyboard,
} from "components/Keyboard"
import { ReactNode, Ref } from "react"

export interface ISearchKeyboardProps
  extends Pick<IKeyboardProps, "languages"> {
  value?: string
  onChange: (input: string) => void
  topKeywordAdornment?: ReactNode
  bottomKeywordAdornment?: ReactNode
  keyboardRef: Ref<ISimpleKeyboardRef>
  sx?: SxProps
}

export const SearchKeyboard: React.FC<ISearchKeyboardProps> = ({
  value = "",
  onChange,
  topKeywordAdornment = null,
  bottomKeywordAdornment = null,
  keyboardRef,
  languages,
  sx = {},
}) => {
  const theme = useTheme()
  const { root } = theme.components[`VuiSearchKeyboard`]?.styleOverrides || {}

  return (
    <Box className="VuiSearchKeyboard-root" sx={deepmerge(root, sx)}>
      {topKeywordAdornment}
      <Keyboard
        inputValue={value}
        ref={keyboardRef}
        onChange={onChange}
        languages={languages}
      />
      {bottomKeywordAdornment}
    </Box>
  )
}
